// extracted by mini-css-extract-plugin
module.exports = {"titleSide":"DetailPage_titleSide__3oiKy","titleMain":"DetailPage_titleMain__JhDMZ"};